<template>
	<Icon>
		<template #component>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="2 2 20 20">
				<path fill="currentColor" d="M17 17q-1.8 0-3.175-1.137T12.1 13H6.8q-.3.675-.925 1.088T4.5 14.5q-1.05 0-1.775-.725T2 12t.725-1.775T4.5 9.5q.75 0 1.375.413T6.8 11h5.3q.35-1.725 1.725-2.863T17 7q2.075 0 3.538 1.463T22 12t-1.463 3.538T17 17m0-2q1.25 0 2.125-.875T20 12t-.875-2.125T17 9t-2.125.875T14 12t.875 2.125T17 15"/>
			</svg>
		</template>
	</Icon>
</template>

<script>
import Icon from '@ant-design/icons-vue';

// https://icones.js.org/collection/material-symbols?s=line&icon=material-symbols:linear-scale
export default {
	components: { Icon },
};
</script>
